export const acknowledgment = [
  {
    title: "Application for Bachelor of Dental Medicine Program - BDM",
    arabicTitle: "",
    text: `Admission to the Bachelor of Dental Medicine program for the academic year 2026/2027 is competitive and according to the college capacity and the availability of seats. Meeting the minimum requirements or submitting the required documents does not mean acceptance or admission to the university.`,
    termsAndConditions: [
      {
        title: "Minimum Admission Requirements",
        conditions: [
          {
            text: `1. **Academic Qualifications**:
            • A minimum **90% general secondary school average (scientific stream)** or its equivalent in Kuwait, as recognized by the American University of Medical Sciences.`
          },
          {
            text: `2. **English Language Proficiency**:
            • Minimum IELTS 5.5 score or its equivalent (dated within the last two years).`
          },
          {
            text: `3. **Personal Interview**:
            • Applicants must pass the university’s **personal interview**.`
          },
          {
            text: `4. **Submission of Required Documents**:
            • All required documents must be submitted to the university administration by the specified application period deadline.`
          },
          {
            text: `5. **Fees Payment**:
            • Applicants must pay the non-refundable application fees to be considered a valid application.`
          }
        ]
      }
    ],
    admissionValidity: "Admission is valid only for the semester for which the student was accepted.",
    requiredDoc: [
      {
        title: "Required Documents for Admission (Upload) All in PDF Format:",
        conditions: [
          { text: "1. Official grade transcript or certified copy." },
          { text: "2. Equivalency of high school degree issued by the Ministry of Education in Kuwait (for private school graduates)." },
          { text: "3. Valid IELTS/TOEFL score report (no older than two years)." },
          { text: "4. Copy of birth certificate." },
          { text: "5. Valid National ID and valid passport photocopies." },
          { text: "6. passport-sized photographs" },
          { text: "7. Certificate of good conduct (from school)" },
          { text: "8. Valid National ID and valid passport photocopies of parents / or legal guardian." },
          { text: "9. Applicants aged 21 and above: provide criminal record certificate" },
          { text: "10. Kuwaiti Applicants: Certificate proof of citizenship of father- from Sahal App" }
        ],
        subtitle: "Additional documents may be required from admission office in the College of Dental Medicine."
      }
    ],
    notes: [
      {
        title: "Note",
        points: [
          {
            text: `Admission is extremely competitive and is based on the strength of the applicant pool and the available capacity.`
          },
          {
            text: `Note that fulfilling the requirements and admission conditions does not mean acceptance into the university.`
          }
        ]
      }
    ]
  }
];
